import { Component, Inject, OnInit, SecurityContext } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { AccountPlan } from '@vendasta/constant-contact';
import { Observable } from 'rxjs';
import { AppConfig, AppConfigService } from '../../app-config.service';

export type PlanOptionValue = AccountPlan;

export interface PlanOption {
  name: string;
  value: PlanOptionValue;
}

export interface ChangePlanData {
  options: PlanOption[];
  moreDetailsMessageHTML: string;
  currentPlan$: Observable<PlanOption>;
  onSubmit: (plan: PlanOptionValue) => void;
}

@Component({
  styleUrls: ['change-plan-dialog.component.scss'],
  templateUrl: './change-plan-dialog.component.html',
  standalone: false,
})
export class ChangePlanDialogComponent implements OnInit {
  private sanitizedMessage: string;
  appConfig$: Observable<AppConfig>;
  chosenPlanValue: PlanOptionValue;
  confirmCheck = false;

  constructor(
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<ChangePlanDialogComponent>,
    private appConfigService: AppConfigService,
    @Inject(MAT_DIALOG_DATA) public changePlanData: ChangePlanData,
  ) {}

  ngOnInit(): void {
    this.appConfig$ = this.appConfigService.config$;
    this.sanitizedMessage = this.sanitizer.sanitize(SecurityContext.HTML, this.changePlanData.moreDetailsMessageHTML);
  }

  submit(plan: PlanOptionValue): void {
    this.changePlanData.onSubmit(plan);
    this.close();
  }

  close(): void {
    this.dialogRef.close();
  }

  updatePlanSelected(value: PlanOptionValue): void {
    this.chosenPlanValue = value;
  }
}
